"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClassMode = void 0;
const Log_1 = __importDefault(require("@common/Log"));
class ClassMode {
    static isOn() {
        try {
            return sessionStorage.getItem(ClassMode.KEY) === "true";
        }
        catch (_err) {
            return ClassMode.fallback;
        }
    }
    static set(on) {
        ClassMode.fallback = on;
        try {
            if (on === true) {
                sessionStorage.setItem(ClassMode.KEY, "true");
            }
            else {
                sessionStorage.removeItem(ClassMode.KEY);
            }
        }
        catch (err) {
            Log_1.default.warn("ClassMode::set( " + on + " ) - sessionStorage unavailable; this page only. ERROR: " + (err === null || err === void 0 ? void 0 : err.message));
        }
    }
    static clear() {
        ClassMode.set(false);
    }
    static show(el, visible) {
        if (el === null) {
            return;
        }
        if (visible === true) {
            if (typeof el.dataset.classModeDisplay === "string") {
                el.style.display = el.dataset.classModeDisplay;
                delete el.dataset.classModeDisplay;
            }
        }
        else if (typeof el.dataset.classModeDisplay !== "string") {
            el.dataset.classModeDisplay = el.style.display;
            el.style.display = "none";
        }
    }
    static showFilter(labelId, selectId, visible) {
        var _a;
        ClassMode.show(document.getElementById(labelId), visible);
        const select = document.getElementById(selectId);
        ClassMode.show(select, visible);
        const widget = (_a = select === null || select === void 0 ? void 0 : select.tomselect) === null || _a === void 0 ? void 0 : _a.wrapper;
        ClassMode.show(widget !== null && widget !== void 0 ? widget : null, visible);
    }
}
exports.ClassMode = ClassMode;
ClassMode.KEY = "classyClassMode";
ClassMode.SUBJECT_COLUMN = "repoId";
ClassMode.fallback = false;
